/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Auth from "../../shared/Auth";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import './Dashboard.css';
import Globals from "../../shared/Globals";
import { CardPrimary } from "./NewDashboard";
import WorkorderBreakdownChart from "../chart/project/WorkorderBreakdownChart";
import L from "../Lang";


class GenDashboard extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            user: null
        };
    }

    async componentDidMount() {
        Auth.getLogin(u => {
            this.setState({ user: u });
        });
        await this.getSettings();
    }

    render() {
        return <div className="Dashboard dashboard-redesign container-fluid">
            <h1 className="d-none"><L>DASHBOARD</L></h1>
            <header className="dashboard-welcome">
                <div className="dashboard-eyebrow"><L>Dashboard</L></div>
                <div className="dashboard-greeting" role="heading" aria-level="1">
                    <L>{Globals.getTimeOfDay('Good ')}</L>{this.state.user?.name ? `, ${this.state.user.name}` : ''}.
                </div>
                <p><L>Your workspace at a glance.</L></p>
            </header>

            <div className="row">
                <div className="col-12 col-xl-8 mt-3">
                    <CardPrimary title={<L>Work Order Breakdown</L>}>
                        <WorkorderBreakdownChart />
                    </CardPrimary>
                </div>
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(GenDashboard);
